export default __webpack_public_path__ + "static/media/green-thin.cb7b8f1c.webp";